import React from 'react';
import { theme } from '@fiverr-private/theme';
import { SYSTEM_ICON_SIZES } from '../../constants';
import type { SystemIconType } from '../../types';

const ChevronLeftIcon = ({ size = 'sm', color = 'currentColor' }: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill={theme.colors[color]}
    viewBox="0 0 16 16"
  >
    <path d="m5.11 8.266 4.62 4.624a.38.38 0 0 0 .536 0l.623-.619a.373.373 0 0 0 0-.531L7.16 8l3.73-3.74a.373.373 0 0 0 0-.531l-.623-.619a.38.38 0 0 0-.535 0L5.11 7.734a.373.373 0 0 0 0 .532" />
  </svg>
);
ChevronLeftIcon.displayName = 'ChevronLeftIcon';
export default ChevronLeftIcon;
